
      export interface IntrospectionResultData {
        __schema: {
          types: {
            kind: string;
            name: string;
            possibleTypes: {
              name: string;
            }[];
          }[];
        };
      }
      const result: IntrospectionResultData = {
  "__schema": {
    "types": [
      {
        "kind": "INTERFACE",
        "name": "TranscodedSource",
        "possibleTypes": [
          {
            "name": "FileSource"
          },
          {
            "name": "RecordSource"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "SourceReference",
        "possibleTypes": [
          {
            "name": "FileSource"
          },
          {
            "name": "RecordSource"
          },
          {
            "name": "RtmpInput"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "Playbackable",
        "possibleTypes": [
          {
            "name": "FileSource"
          },
          {
            "name": "RecordSource"
          },
          {
            "name": "Channel"
          }
        ]
      }
    ]
  }
};
      export default result;
    